<template>
    <div class="mobile-tab-list">
        <VJoySelect name="navtab" data-testid="navtab" :model-value="activateTabName" @update:model-value="handleTabChange">
            <option v-for="{id, name} of formattedTabsToOptions" :key="id" :value="id">
                {{ name }}
            </option>
        </VJoySelect>
    </div>
</template>

<script setup lang="ts">
    import type {PropType} from 'vue';
    import {computed} from 'vue';
    import type {SelectOptionItem, TabItem} from '@common/types';
    import {useRoute, useRouter} from '@typed-router';
    import {VJoySelect} from '@maltjoy/core-vue';

    const props = defineProps({
        tabs: {type: Array as PropType<TabItem[]>, required: true},
    });

    const $route = useRoute();
    const $router = useRouter();

    const activeTab = computed(() => {
        return props.tabs.find((tab) => {
            return typeof tab.to !== 'string' && tab.to.name === $route.name.replace('id-', '');
        });
    });

    const activateTabName = computed<string | null>(() => activeTab?.value?.name ?? null);

    const formattedTabsToOptions = computed<SelectOptionItem[]>(() =>
        props.tabs.map(({title, name}) => ({
            id: name,
            name: title,
        })),
    );

    async function handleTabChange(value: string) {
        try {
            await $router.replace(value);
        } catch {}
    }
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text';

    .mobile-tab-list {
        padding: var(--joy-core-spacing-4);
    }
</style>
